import { useEffect } from 'react';

/**
 * Takes in an element and callback to handle clicking outside that element
 *
 * @param {Object} ref - The element ref
 * @param {function} fn - The callback function to execute when clicking outside the element
 * @param {node} node - Optional node, if provided will be used instead of the ref
 */

const useClickOutside = function (ref, fn) {
  let node = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  useEffect(() => {
    const handleClickOutside = event => {
      const element = node || ref && ref.current;
      if (element && !element.contains(event.target)) {
        fn(event);
      }
    };
    window.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('touchstart', handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('touchstart', handleClickOutside);
    };
  }, [ref, fn, node]);
};
var useClickOutside$1 = useClickOutside;

export { useClickOutside$1 as default };
